export const challengeRulesLink = {
  notation:
    'https://drive.google.com/file/d/1qfmDTmYeEL3Sd_vdUclpcEjJZkni_olB/view?usp=sharing ',
  reglement:
    'https://drive.google.com/file/d/1CzqZAP5YEJLlMyu3T6S58t_pNIo2F2OU/view?usp=sharing',
  book: 'https://drive.google.com/file/d/1_lnDoqLTATy0Hzq_ByrgADX9JKhOlm8n/view'
};
